exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.lnr-sync[data-v-dba5fc96], .lnr-magnifier[data-v-dba5fc96] {\n    display: inline-block;\n}\n.tree-node[data-v-dba5fc96] {\n    font-size: 14px;\n}\ncode[data-v-dba5fc96] {\n    display: inline-block;\n    font-size: 12px;\n    margin-right: 3px;\n}\n.search-filter[data-v-dba5fc96] {\n    max-height: 700px;\n    overflow-y: auto;\n    margin-top: 15px;\n}\n", ""]);

// exports
